import { useRef } from 'react';
import styles from './buttonStyles.module.css';

export const NewFileModal = ({ handleOnchange, setModalIsOpen, postFileOrFolder, handleOpenModal }) => {
    const addBtnRef = useRef(null);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            postFileOrFolder();
        }
    };

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#e8eaf6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>
                    📄
                </div>
                <div>
                    <div style={{ fontSize: 17, fontWeight: 700, color: '#2d3748', lineHeight: 1.2 }}>New File</div>
                    <div style={{ fontSize: 12, color: '#718096', marginTop: 2 }}>Name your Python file</div>
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', border: '2px solid #c5cae9', borderRadius: 8, overflow: 'hidden', background: '#fff', marginBottom: '20px' }}>
                <input
                    style={{ flex: 1, padding: '10px 12px', border: 'none', outline: 'none', fontSize: 14, color: '#2d3748', minWidth: 0 }}
                    type="text"
                    placeholder="filename"
                    autoFocus
                    onChange={(e) => handleOnchange({ target: { value: e.target.value + '.py' } })}
                    onKeyDown={handleKeyDown}
                />
                <span style={{ padding: '10px 12px', background: '#e8eaf6', color: '#5c6bc0', fontWeight: 700, fontSize: 13, borderLeft: '2px solid #c5cae9', userSelect: 'none', whiteSpace: 'nowrap' }}>
                    .py
                </span>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                <button className={styles.cancle} onClick={() => { setModalIsOpen(false); handleOpenModal(false); }}>Cancel</button>
                <button ref={addBtnRef} className={styles.sucess} onClick={() => { postFileOrFolder(); }}>Add</button>
            </div>
        </div>
    );
};
